import * as React from 'react';

import { DataItem } from '../DataItem';

interface IStatusProps {
  status: string;
}

export const Status: React.FC<IStatusProps> = ({ status }) => {
  return <DataItem header="Сдача комплекса" text={status} />;
};
